export const API_EXTERNAL_ENDPOINT = 'destinos/:slug'
export const API_INTERNAL_ENDPOINT = 'strapi/destinos/detail'
